export const formatTime = (timestamp: number) => {
  const hours = Math.floor(timestamp / 3600);
  const minutes = `${Math.floor(timestamp / 60) % 60}`.padStart(hours > 0 ? 2 : 1, '0');
  const seconds = `${Math.floor(timestamp / 1) % 60}`.padStart(2, '0');

  return `${hours > 0 ? `${hours}:` : ''}${minutes}:${seconds}`;
};
